import { StyleSheet } from "@react-pdf/renderer";
import theme from "../../../../../css/WhiteLabelledDocuments/theme";
import { Font } from "@react-pdf/renderer";
import OpenSansBold from "../../../../../assets/fonts/Open_Sans/OpenSans-Bold.ttf";
import OpenSansRegular from "../../../../../assets/fonts/Open_Sans/OpenSans-Regular.ttf";
import OpenSansItalic from "../../../../../assets/fonts/Open_Sans/OpenSans-Italic.ttf";
import RalewayRegular from "../../../../../assets/fonts/Raleway/Raleway-Regular.ttf";
import RalewayMedium from "../../../../../assets/fonts/Raleway/Raleway-Medium.ttf";
import RalewaySemiBold from "../../../../../assets/fonts/Raleway/Raleway-SemiBold.ttf";
import RalewayBold from "../../../../../assets/fonts/Raleway/Raleway-Bold.ttf";
import { blendWithWhite, blendWithWhite10 } from "../Utils/getColor";

Font.register(
  {
    family: "Open Sans",
    fonts: [
      { src: OpenSansBold, fontWeight: "bold" },
      { src: OpenSansRegular, fontWeight: "normal" },
      { src: OpenSansItalic, fontStyle: "italic" },
    ],
  },
  {
    family: "Raleway",
    fonts: [
      {
        src: RalewayRegular,
        fontWeight: 400,
      },
      {
        src: RalewayMedium,
        fontWeight: 500,
      },
      {
        src: RalewaySemiBold,
        fontWeight: 600,
      },
      {
        src: RalewayBold,
        fontWeight: 700,
      },
    ],
  },
);

const Styles = (primaryColor) =>
  StyleSheet.create({
    page: {
      position: "relative",
      paddingTop: 50, //  VERY IMPORTANT (push content below header)
      paddingHorizontal: 20,
      paddingBottom: 40,

      // paddingBottom: 40,
    },
    image: {
      width: "auto",
      height: 80,
    },

    graphicWrapper: {
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
    },
    graphicBox: {
      position: "absolute",
      top: "-102%",
      left: "-60%",
      width: "110%",
      height: "250%",
      backgroundColor: blendWithWhite(primaryColor, 0.6),
      transform: "rotate(45deg)",
    },
    graphicBox1: {
      position: "absolute",
      bottom: "40%",
      right: "-130%",
      width: "190%",
      height: "250%",
      backgroundColor: `#${primaryColor}`,
      transform: "rotate(35deg)",
    },
    graphicBox2: {
      position: "absolute",
      bottom: "73%",
      right: "-20%",
      width: "200%",
      height: "2%",
      backgroundColor: blendWithWhite10(primaryColor, 0.8),
      transform: "rotate(35deg)",
    },
    graphicBox3: {
      position: "absolute",
      bottom: "75.3%",
      right: "-20%",
      width: "200%",
      height: "2%",
      backgroundColor: blendWithWhite10(primaryColor, 0.3),
      transform: "rotate(35deg)",
    },

    h3: {
      fontFamily: "Raleway",
      fontSize: 24,
      fontWeight: 600,
      color: `#${primaryColor}`,
      textAlign: "center",
      // lineHeight: 32,
      // marginBottom: 6,
    },

    ContentSmall: {
      fontSize: 14,
      fontWeight: 400,
      color: theme.colors.Black,
      fontFamily: "Open Sans",

      // lineHeight: 20,
    },
    LabelSmallItalic: {
      fontSize: 12,
      fontStyle: "italic",
      color: theme.colors.Black,
      fontFamily: "Open Sans",
      // lineHeight: 16,
      flexWrap: "wrap",
      whiteSpace: "pre-wrap",
      width: "100%",
    },
    LabelSmallSemiBold: {
      fontSize: 12,
      fontWeight: 600,
      fontFamily: "Open Sans",
      // lineHeight: 16,
    },
    ButtonTextSmall: {
      fontSize: 12,
      fontWeight: "normal",
      color: theme.colors.Black,
      fontFamily: "Open Sans",
      // lineHeight: 16,
    },
    ContentSemiBold: {
      fontSize: 16,
      fontWeight: 600,
      color: `#${primaryColor}`,
      fontFamily: "Open Sans",
      // lineHeight: 24,
    },

    subcontent: {
      fontFamily: "Open Sans",
      fontWeight: "bold",
      textAlign: "justify",
      fontSize: 10,
      // lineHeight: 1.5,
      color: `#${primaryColor}`,
    },

    centeredContent: {
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      textAlign: "center",
      // gap: 16,
      // height: "100%",
      marginTop: 550,
    },

    SpaceAroundRow: {
      flexDirection: "row",
      justifyContent: "space-around",
      alignItems: "flex-start",
      width: "100%",
    },

    // Column layout
    FlexStartColumn: {
      flexDirection: "column",
      justifyContent: "flex-start",
      alignItems: "flex-start",
      textAlign: "left",
      // flex: 1,
      gap: 4,
    },

    // Right column (if you want right-aligned contact info)
    FlexEndColumn: {
      flexDirection: "column",
      alignItems: "flex-end",
      textAlign: "right",
      flex: 1,
      gap: 4,
    },

    header: {
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      height: 56,
      flexDirection: "row",
      justifyContent: "flex-end",
      alignItems: "center",
      paddingHorizontal: 40,
      // borderBottomWidth: 1,
      // borderBottomColor: "#E5E5E5",
    },

    headerLogo: {
      height: 40,
      width: "auto",
    },

    panel: {
      // backgroundColor: "#EEF3FF",
      paddingLeft: 14,
      paddingBottom: 0,
      marginTop: 10,
      gap: 6,
      marginBottom: 0,
      display: "flex",
      // height:"fit-content",
      flexDirection: "column",
      // flex: 1,
      borderLeftWidth: 3,
      borderLeftColor: `#${primaryColor}`,
      // borderRadius: 6,
    },

    // spacing between rows
    rowGap: {
      marginBottom: 10,
    },

    heading: {
      fontSize: 14,
      fontWeight: 700,
      color: `#${primaryColor}`,
      marginBottom: 12,
    },
    fieldRow: {
      flexDirection: "row",
      alignItems: "center",
      flexWrap: "nowrap", //  important
      // flexDirection: "row",
      // alignItems: "flex-start",
      // justifyContent: "center",
      // marginBottom: 6,

      gap: 6,
    },
    cols: {
      flexDirection: "column",
      width: "100%",
      gap: 24,
    },
    row: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
      width: "100%",
      marginBottom: 0,
      gap: 24,
    },
    col: {
      width: "100%",
      maxWidth: 260,
    },
    homeTitleRow: {
      flexDirection: "row",
      alignItems: "center",
      marginBottom: 6,
    },
    sectionTitle: {
      fontSize: 10,
      fontWeight: 700,
      marginBottom: 6,
    },
    subNote: {
      fontSize: 8,
      color: "#6B7890",
      marginLeft: 4,
      marginBottom: 6,
    },
    fieldColumn: {
      flexDirection: "column",
      alignItems: "flex-start",
      width: "100%",
    },
    lineFull: {
      width: "100%",
      height: 16,
      backgroundColor: theme.colors.GhostWhite,
    },

    label: {
      // width: 78,
      fontSize: 9,
    },
    line: {
      flexGrow: 1,
      height: 16,
      width: "100%",
      marginTop: 2,
      // marginBottom: 2,
      backgroundColor: theme.colors.GhostWhite,
    },
    blockGap: {
      marginBottom: 14,
    },
    dateRow: {
      flexDirection: "row",
      alignItems: "center",
    },
    dateBox: {
      width: 16,
      height: 16,
      // borderWidth: 1,
      backgroundColor: theme.colors.GhostWhite,
      marginRight: 4,
    },
    slash: {
      fontSize: 11,
      marginHorizontal: 6,
    },

    leftTitle: {
      fontSize: 12,
      fontWeight: 700,
      color: `#${primaryColor}`,
    },

    FooterTextSmall: {
      fontSize: 8,
      fontWeight: "400",
      color: theme.colors.White,
      textAlign: "center",
      fontFamily: "Open Sans",
      width: "90%",
    },

    footer: {
      position: "absolute",
      bottom: 0,
      left: 0,
      right: 0,
      minHeight: 32,
      display: "flex",
      justifyContent: "center",
      paddingHorizontal: 30,
      backgroundColor: `#${primaryColor}`,
    },

    rightText: {
      fontSize: 10,
      color: `#${primaryColor}`,
      fontWeight: 700,
    },

    numberBox: {
      width: 16,
      height: 16,
      backgroundColor: theme.colors.GhostWhite,
      marginHorizontal: 2,
    },

    note: {
      fontSize: 9,
      color: "#6B7890",
      marginRight: 2,
      marginTop: 1,
    },

    title: {
      fontSize: 12,
      fontWeight: 700,
      color: `#${primaryColor}`,
      // marginBottom: 10,
    },

    // each half of the row (left card set / right card set)
    half: {
      width: "48%",
      maxWidth: 280,
      flexDirection: "row",
      justifyContent: "space-between",
    },

    // column inside each half
    fieldColNumber: {
      width: "30%",
    },
    fieldColExpiry: {
      width: "30%",
    },
    // line: {
    //   height: 14,
    //   borderWidth: 1,
    //   borderColor: "#D7DEED",
    //   backgroundColor: "#FFFFFF",
    //   marginBottom: 6,
    // },
  });

export default Styles;
